





































































import { Component, Ref, Mixins, Vue } from "vue-property-decorator";
import liff from "@line/liff";
import Logo from "@/components/Logo.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { VuetifyFieldValidationRules } from "@/utils/constants";

@Component({ components: { Logo, LoadingSpinner } })
export default class Login extends Vue {
  public email = "";
  public password = "";
  public showPassword = false;
  public errorMessage = "";
  public isAuthLoading = false;
  public valid = false;

  @Ref() readonly form!: HTMLFormElement;

  get emailRules(): VuetifyFieldValidationRules {
    return [
      (v: string) => !!v || "请输入相关信息",
      (v: string) => /.+@.+/.test(v) || "邮箱格式无效，请检查后重新输入"
    ];
  }

  get passwordRules(): VuetifyFieldValidationRules {
    return [(v: string) => !!v || "请输入相关信息"];
  }

  public async login() {
    if (!this.form.validate()) {
      return;
    }

    try {
      this.isAuthLoading = true;
      this.errorMessage = "";
      await Vue.$authentication.authorize(this.email, this.password);
      if (!liff.isInClient()) {
        return;
      } else {
        liff.closeWindow();
      }
      this.isAuthLoading = false;
    } catch (error) {
      this.isAuthLoading = false;
      this.errorMessage = "登录邮箱或密码错误，请重新填写后再尝试";
    }
  }
}
